import React, { useEffect, useState } from "react";
import { Row, Typography, Button, Col, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

import styles from "./styles/MyAccountPage.module.css";

import { getUser } from "../../http-request/user";
import Title from "antd/lib/typography/Title";
import { details } from "~constants";


const { Paragraph } = Typography;

function MyAccountPage() {
  const [userDetails, setuserDetails] = useState();
  const [userInfoRaw, setuserInfoRaw] = useState();
  const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

  const navigate = useNavigate();
  useEffect(() => {
    getEstablishmentByToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEstablishmentByToken = async () => {
    let token = localStorage.getItem("token");
    const { user } = await getUser(token);
    if (user) {

      Object.keys(user).forEach((keys, index) => {
        details.forEach((item) => {
          if (item.property === keys && item.property !== "establishments") {
            item.value = user[keys];
          } else if (
            keys === "establishments" &&
            item.property === "establishments"
          ) {
            item.value = user[keys][0]["name"];
          }
        });
      });

      setuserDetails(details);
      setuserInfoRaw(user);

    }
  };

  return (
    <div className={styles.container}>
      <center>
        <div className={styles.content}>
          <Row align="middle" justify="space-between" style={{ marginTop: 20 }}>
            <Link to={-1}>
              <ArrowLeftOutlined style={{ fontSize: 20 }} />
            </Link>
            <Title level={3} style={{ textAlign: "left" }}>
              My Account
            </Title>
          </Row>

          {userDetails ? (
            <>
              <div className={styles.info}>
                {userDetails.map((item, index) => (
                  <Row key={index} justify="center" gutter={10} align="middle">
                    <Col span={8}>
                      <Paragraph style={{ textAlign: "left" }} ellipsis>
                        <strong> {item.label}:</strong>
                      </Paragraph>
                    </Col>
                    <Col span={14}>
                      <Paragraph style={{ textAlign: "start" }} ellipsis>
                        {item.value}
                      </Paragraph>
                    </Col>
                  </Row>
                ))}
              </div>

              <Button
                disabled={userDetails ? false : true}
                block
                type="primary"
                icon={<EditOutlined />}
                onClick={() =>
                  navigate("edit", { state: { user: userInfoRaw } })
                }
              >
                Edit
              </Button>
            </>
          ) : (
            <Row justify="center" align="middle" className={styles.contentRow}>
              <Spin indicator={antIcon} />
            </Row>
          )}
        </div>
      </center>
    </div>
  );
}

export default MyAccountPage;
